import {hideOverlay} from '../../overlay-actions';
import {setOrderIsProcessing} from '../../site-actions';

const startNewpayCheckout = (checkoutCertificate, dispatch) => {
  dispatch(hideOverlay());
  dispatch(setOrderIsProcessing(false));
  return Promise.resolve(checkoutCertificate);
};

export default startNewpayCheckout;
